import script from "./LaporanDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./LaporanDetailView.vue?vue&type=script&setup=true&lang=js"

import "./LaporanDetailView.vue?vue&type=style&index=0&id=6d996a30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d996a30"]])

export default __exports__